<template>
  <div class="no-cart" v-if="data.length===0 && token">
    <img :src="nocartSrc">
    <p>购物车还没有商品哦~</p>
  </div>
  <div v-else class="cart-wrapper">
    <div class="each-list">
      <van-swipe-cell
        v-for="item in validData"
        :on-close="(a,b)=>onDelete(a,b,item.id)"
        :key="item.id"
        :right-width="rightWidth"
      >
        <span slot="right" class="swipe-delete">删除</span>
        <div class="each-goods">
          <div class="cart-left" @click="selectGoods(item)">
            <img :src="computedSelectImg(item.id)" class="selector">
          </div>
          <div class="mid" @click="selectGoods(item)">
            <img :src="item.thumbimg" class="img-responsive">
          </div>
          <div class="cart-right">
            <div class="cart-inner-top" v-text="item.name"></div>
            <div class="cart-inner-center" v-text="item.specsName"></div>
            <div class="cart-inner-bottom">
              <div class="price-wra">
                ￥
                <span class="price" v-text="item.price"></span>
              </div>
              <stepper
                v-model="item.quantity"
                :max="item.stock === -1 ? undefined : item.stock"
                :min="1"
                @plus="plusItemNumber(item,arguments)"
                @minus="decreaseItemNumber(item,arguments)"
                @change="countChange(item,arguments)"
                integer
              />
            </div>
          </div>
        </div>
      </van-swipe-cell>
    </div>
    <div class="each-list no-use">
      <van-swipe-cell
        v-for="item in nouseData"
        :on-close="(a,b)=>onDelete(a,b,item.id)"
        :key="item.id"
        :right-width="rightWidth"
      >
        <span slot="cart-right" class="swipe-delete">删除</span>
        <div class="each-goods">
          <div class="cart-left">
            <div class="no-use"></div>
          </div>
          <div class="mid">
            <img :src="item.thumbimg" class="img-responsive">
          </div>
          <div class="mid-shadow">失效商品</div>
          <div class="cart-right">
            <div class="cart-inner-top no-use" v-text="item.name"></div>
            <div class="cart-inner-center no-use" v-text="item.specsName"></div>
            <div class="cart-inner-bottom">
              <div class="price-wra no-use">
                ￥
                <span class="price" v-text="item.price"></span>
              </div>
            </div>
          </div>
        </div>
      </van-swipe-cell>
    </div>
    <div class="submit-wrapper" v-if="nouseData.length !== data.length">
      <div class="total" v-cloak>
        <div class="select-all" @click="selectAll">
          <img :src="isAllSelect?selectedImg:unselectImg" alt>
          <span>{{isAllSelect?'取消':'全选'}}</span>
        </div>
        <div class="pr">
          <div class="price-wra">
            <span class="suffix">￥</span>
            <span class="price">{{totalPrice}}</span>
          </div>
        </div>
      </div>
      <div class="confirm-btn" @click.stop="submitToOrder">提交订单</div>
    </div>
  </div>
</template>

<script>
import { _auth } from "@/js/auth";
export default {
  name: "GoodsCart",
  components: {},
  props: {
    // layouts: String,
    // layoutType: String,
  },
  data() {
    return {
      currentSelect: [],
      data: [],
      selectedImg: "",
      unselectImg: "",
      isAllSelect: false,
      rightWidth: window.innerWidth * 0.26666,
      nocartSrc: "",
      token: sessionStorage.getItem("token") || ""
    };
  },
  computed: {
    validData() {
      return this.data.filter(e => e.isEnabled);
    },
    nouseData() {
      return this.data.filter(e => !e.isEnabled);
    },
    totalPrice() {
      if (this.currentSelect.length === 0) return 0;
      let total = 0;
      this.currentSelect.forEach(e => {
        total += e.price * e.quantity;
      });
      return total.toFixed(2);
    }
  },
  watch: {
    currentSelect(arr) {
      this.isAllSelect = arr.length === this.validData.length ? true : false;
    }
  },
  created() {
    if (this.token) {
      this.getGoodsData();
    } else {
      _auth(this, () => {
        this.getGoodsData();
      });
    }
  },
  mounted() {
    this.nocartSrc = API.ossUrl + "common/empty_icons/nocart.png";
    this.selectedImg = API.ossUrl + "goods/png/selected.png";
    this.unselectImg = API.ossUrl + "goods/png/unselect.png";
  },
  destroyed() {},
  methods: {
    countChange({ id, quantity }, _vm) {
      this.updateItemNumber(id, +quantity, isPass => {
        if (isPass) _vm[0].onChange("plus");
      });
    },
    selectGoods(item) {
      let index = this.currentSelect.findIndex(e => e.id == item.id);
      if (index > -1) {
        this.currentSelect.splice(index, 1);
      } else {
        this.currentSelect.push(item);
      }
    },
    getGoodsData() {
      this.$axios
        .get(`${window.API.goods.listCart}?token=${sessionStorage.token}`)
        .then(({ data }) => {
          if (data.code == 200) {
            this.data = data.data;
            this.isAllSelect = false;
            this.currentSelect = [];
          } else {
            this.$toast(data.msg);
          }
        })
        .catch(err => console.log(err));
    },
    computedSelectImg(id) {
      if (this.currentSelect.find(e => e.id === id)) {
        return this.selectedImg;
      }
      return this.unselectImg;
    },
    selectAll() {
      if (this.isAllSelect) {
        this.currentSelect = [];
      } else {
        this.currentSelect = [...this.validData];
      }
      this.isAllSelect = !this.isAllSelect;
    },
    plusItemNumber({ id, quantity }, _vm) {
      this.updateItemNumber(id, +quantity + 1, isPass => {
        if (isPass) _vm[0].onChange("plus");
      });
    },
    decreaseItemNumber({ id, quantity }, _vm) {
      this.updateItemNumber(id, +quantity - 1, isPass => {
        if (isPass) _vm[0].onChange("minus");
      });
    },
    updateItemNumber(id, quantity, cb) {
      let index = this.data.find(e => e.id == id);
      this.$axios
        .post(
          `${window.API.goods.updateCart}/${id}?token=${sessionStorage.token}`,
          {
            quantity
          }
        )
        .then(({ data }) => {
          if (data.code == 200) {
            cb(true);
          } else {
            cb(false);
          }
        })
        .catch(err => cb(false));
    },
    onDelete(clickPosition, instance, id) {
      let vm = this;
      switch (clickPosition) {
        case "left":
        case "cell":
        case "outside":
          instance.close();
          break;
        case "right":
          vm.$confirm({
            content: "确定要删除吗？",
            yesText: "确定",
            noText: "取消"
          })
            .then(() => {
              vm.deleteItem(id);
            })
            .catch(e => console.log(e));
          break;
      }
    },
    deleteItem(id) {
      this.$axios
        .post(`${window.API.goods.delCart}/${id}?token=${sessionStorage.token}`)
        .then(({ data }) => {
          if (data.code == 200) {
            this.$toast("删除成功");
            this.getGoodsData();
          } else {
            this.$toast(data.msg);
          }
        })
        .catch(err => console.log(err));
    },
    submitToOrder() {
      if (this.currentSelect.length === 0) {
        this.$alert("请至少选择一个商品！");
        return;
      }
      // sessionStorage.goods = JSON.stringify(this.validData);
      let ids = this.currentSelect.map(e => e.specs_id).toString();
      let cart_ids = this.currentSelect.map(e => e.id).toString();
      let itemCount = {};
      this.currentSelect.forEach(e => {
        itemCount[e.specs_id] = e.quantity;
      });
      //存储购物车specsid为逗号分隔的字符串
      sessionStorage.goodsIdList = ids;
      //存储购物车购物车id即id为逗号分隔的字符串
      sessionStorage.goodsCartIdList = cart_ids;
      //存储购物车中每一个specs_id对应的商品的数量
      sessionStorage.itemCount = JSON.stringify(itemCount);

      this.$router.push({
        name: "goodsOrder",
        params: {
          type: 1
        }
      });
    }
  }
};
</script>


<style scoped lang="scss">
.no-cart {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFang-SC-Bold;

  flex-direction: column;
  margin-top: 42%;
  img {
    width: 6.613333rem;
    height: 5.906667rem;
  }
  p {
    color: #444444;
    font-size: 0.373333rem;
    text-align: center;
    font-weight: bold;
  }
}
.cart-wrapper {
  // padding-top: 0.16rem;
  min-height: 100%;
  .each-list {
    &.no-use {
      margin-top: 0.213333rem;
      margin-bottom: 1.333333rem;
    }
    .swipe-delete {
      background: #ee3a3a;
      font-size: 14px;
      color: $white;
      width: 3.093333rem;
      height: 100%;
      font-weight: 400;
      text-align: center;
      line-height: 3.093333rem;
      display: block;
    }
    .each-goods {
      position: relative;
      padding: 0.32rem;
      padding-left: 0px;
      display: flex;
      align-items: center;
      background: $white;
      // height: 2.746667rem;
      &:last-child {
        border-bottom: 0;
      }
      .cart-left {
        width: 1.226667rem;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .selector {
          width: 0.48rem;
          height: 0.48rem;
        }
        .no-use {
          width: 0.48rem;
          height: 0.48rem;
          background: rgba(241, 241, 241, 1);
          border: 1px solid rgba(241, 241, 241, 1);
          border-radius: 50%;
        }
      }
      .mid {
        width: 2.453333rem;
        height: 2.453333rem;
        border-radius: 10px;
        margin-right: 0.213333rem;
        overflow: hidden;
      }
      .mid-shadow {
        position: absolute;
        top: 0.32rem;
        left: 1.226667rem;
        width: 2.453333rem;
        height: 2.453333rem;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 10px;
        margin-right: 0.213333rem;
        overflow: hidden;
        z-index: 10;
        font-size: 0.373333rem;
        color: $white;
        font-family: PingFang SC;
        font-weight: 600;
        line-height: 2.453333rem;
        text-align: center;
      }
      .cart-right {
        width: 5.7rem;
        .cart-inner-top {
          color: #484848;
          font-size: 15px;
          font-weight: bold;
          margin-bottom: 0.133333rem;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 0.533333rem;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          flex-direction: column;
          &.no-use {
            color: $grey4;
          }
        }
        .cart-inner-center {
          font-size: 14px;
          color: #999;
          font-weight: 400;
          line-height: 0.533333rem;
          margin-top: 0.08rem;
          margin-bottom: 0.053333rem;
          &.no-use {
            color: $grey4;
          }
        }
        .cart-inner-bottom {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .price-wra {
            font-size: 16px;
            color: #ff9200;
            line-height: 0.586667rem;
            &.no-use {
              color: $grey4;
              .price {
                color: $grey4;
              }
            }
            .price {
              font-size: 16px;
              color: $orange;
            }
          }
        }
      }
    }
  }
  .submit-wrapper {
    padding-left: 0.466667rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 1.586667rem;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1);
    background: $white;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 100;
    .total {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex: 1 0 auto;
      .select-all {
        display: flex;
        align-items: center;
        img {
          width: 0.48rem;
          height: 0.48rem;
          margin-right: 0.266667rem;
        }
        span {
          font-size: 14px;
          color: #484848;
        }
      }
      .pr {
        display: flex;
        align-items: center;
      }

      .price-wra {
        margin-right: 0.266667rem;
        .suffix {
          font-size: 26px;
          color: #fe6965;
        }
        .price {
          font-size: 26px;
          color: #fe6965;
          font-weight: bold;
        }
      }
    }
    .confirm-btn {
      margin-right: 0.346667rem;
      line-height: 1.066667rem;
      font-size: 16px;
      font-weight: 500;
      text-align: center;
      color: $white;
      width: 2.96rem;
      height: 1.066667rem;
      background: linear-gradient(
        90deg,
        rgba(248, 199, 64, 1) 0%,
        rgba(245, 149, 38, 1) 100%
      );
      box-shadow: 0px 0px 12px rgba(248, 179, 86, 1);
      border-radius: 0.533333rem;
    }
  }
}
</style>

